export default `/* Ids Splitter Component */
:host {
  visibility: hidden;
}

:host(.ids-splitter-initialized) {
  visibility: visible;
}

:host([text-wrap]) * {
  white-space: normal;
}

.ids-splitter {
  display: flex;
  position: relative;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.ids-splitter.axis-x {
  flex-direction: row;
}
.ids-splitter.axis-y {
  flex-direction: column;
}
.ids-splitter.axis-y .splitter-dragger .splitter-expand-btn {
  top: -16px;
  right: auto;
  left: 50%;
  transform: translateX(-50%);
}
.ids-splitter.axis-y .splitter-dragger .splitter-expand-btn::before {
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-bottom: none;
}
.ids-splitter.axis-y .splitter-dragger .splitter-expand-btn:hover::before {
  border-top-color: var(--ids-splitter-expand-btn-hover-arrow-color);
}
.ids-splitter .splitter-drag-handle {
  background-color: var(--ids-splitter-handle-color-background-hover);
  border-radius: var(--ids-splitter-handle-border-radius);
  display: block;
  height: var(--ids-splitter-handle-height);
  opacity: 0;
  position: absolute;
  margin-inline-start: -3px;
  width: var(--ids-splitter-handle-width);
  z-index: 1;
}
.ids-splitter .splitter-dragger {
  position: absolute;
}
.ids-splitter .splitter-dragger .split-bar {
  border-inline-start: 1px solid var(--ids-splitter-bar-color-border);
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.ids-splitter .splitter-dragger .split-bar:hover {
  border-inline-start: 2px solid var(--ids-splitter-bar-color-border-hover);
}
.ids-splitter .splitter-dragger .split-bar:hover .splitter-drag-handle {
  opacity: 1;
}
.ids-splitter .splitter-dragger .split-bar::before {
  content: "";
  position: absolute;
  height: 100%;
  margin-inline-start: -4px;
  width: var(--ids-splitter-bar-buffer-width);
}
.ids-splitter .splitter-dragger[axis=x] {
  height: 100%;
  top: 0;
  z-index: var(--ids-z-index-40);
}
.ids-splitter .splitter-dragger[axis=x] .split-bar {
  width: var(--ids-splitter-bar-width);
}
.ids-splitter .splitter-dragger[axis=y] {
  left: 0;
  width: 100%;
  z-index: var(--ids-z-index-40);
}
.ids-splitter .splitter-dragger[axis=y] .split-bar {
  border-block-start: 1px solid var(--ids-splitter-bar-color-border);
  border-inline-start: 0;
  height: var(--ids-splitter-bar-width);
}
.ids-splitter .splitter-dragger[axis=y] .split-bar::before {
  height: var(--ids-splitter-bar-buffer-width);
  margin-inline-start: 0;
  margin-block-start: -2px;
  width: 100%;
  z-index: -1;
}
.ids-splitter .splitter-dragger[axis=y] .split-bar:hover {
  border-block-start: 2px solid var(--ids-splitter-bar-color-border-hover);
}
.ids-splitter .splitter-dragger[axis=y][is-dragging] .split-bar, .ids-splitter .splitter-dragger[axis=y]:focus .split-bar {
  border-inline-start: 0;
  border-block-start: 2px solid var(--ids-splitter-bar-color-border-dragging);
}
.ids-splitter .splitter-dragger[axis=y] .splitter-drag-handle {
  margin-block-start: -4px;
  margin-inline-start: 0;
  height: var(--ids-splitter-handle-width);
  width: var(--ids-splitter-handle-height);
}
.ids-splitter .splitter-dragger[is-dragging], .ids-splitter .splitter-dragger:focus {
  outline: none;
}
.ids-splitter .splitter-dragger[is-dragging] .split-bar, .ids-splitter .splitter-dragger:focus .split-bar {
  border-inline-start: 2px solid var(--ids-splitter-bar-color-border-dragging);
}
.ids-splitter .splitter-dragger[is-dragging] .splitter-drag-handle, .ids-splitter .splitter-dragger:focus .splitter-drag-handle {
  opacity: 1;
}
.ids-splitter .splitter-dragger[disabled] {
  display: none;
}
.ids-splitter .splitter-dragger:hover .splitter-expand-btn, .ids-splitter .splitter-dragger.touch-active .splitter-expand-btn {
  opacity: 1;
  visibility: visible;
}
.ids-splitter .splitter-dragger .splitter-expand-btn {
  position: absolute;
  top: 16px;
  width: 24px;
  height: 24px;
  background: var(--ids-splitter-expand-btn-background-color);
  border: 1px solid var(--ids-splitter-expand-btn-border-color);
  border-radius: 8px;
  cursor: pointer;
  z-index: 102;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--ids-splitter-expand-btn-shadow);
  transition: opacity 0.2s ease, transform 0.3s ease;
  opacity: 0;
  visibility: hidden;
  right: -12px;
}
.ids-splitter .splitter-dragger .splitter-expand-btn::before {
  content: "";
  width: 0;
  height: 0;
  border-left: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-top: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  border-bottom: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  transform: rotate(180deg);
}
.ids-splitter .splitter-dragger .splitter-expand-btn:hover {
  background: var(--ids-splitter-expand-btn-hover-background-color);
  border-color: var(--ids-splitter-expand-btn-hover-border-color);
  box-shadow: var(--ids-splitter-expand-btn-hover-shadow);
}
.ids-splitter .splitter-dragger .splitter-expand-btn.is-collapsed {
  opacity: 1;
  visibility: visible;
  inset-inline-end: -12px;
  border: 1px solid var(--ids-splitter-expand-btn-border-color);
  box-shadow: var(--ids-splitter-expand-btn-shadow);
  z-index: 1001;
  background-color: var(--ids-splitter-expand-btn-background-color);
}
.ids-splitter .splitter-dragger .splitter-expand-btn.is-collapsed::after {
  content: "";
  position: absolute;
  left: -2px;
  top: 0;
  width: 2px;
  height: 100%;
}
.ids-splitter .splitter-dragger .splitter-expand-btn[data-collapsed=false]::before {
  transform: rotate(180deg);
}
.ids-splitter .splitter-dragger .splitter-expand-btn[data-collapsed=true]::before {
  transform: rotate(0deg);
}

:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn {
  top: -16px;
  right: auto;
  left: 50%;
  transform: translateX(-50%);
}
:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn::before {
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-bottom: none;
}
:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn.is-collapsed::before {
  transform: rotate(180deg);
}
:host(.rtl) .ids-splitter.axis-y .splitter-dragger .splitter-expand-btn:hover::before {
  border-top-color: var(--ids-splitter-expand-btn-hover-arrow-color);
}

:host(.rtl) .splitter-dragger .splitter-expand-btn {
  right: auto;
  left: -12px;
}
:host(.rtl) .splitter-dragger .splitter-expand-btn::before {
  border-left: none;
  border-right: 4px solid var(--ids-splitter-expand-btn-arrow-color);
  border-top: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  border-bottom: 3px solid var(--ids-splitter-expand-btn-arrow-transparent);
  transform: rotate(0deg);
}
:host(.rtl) .splitter-dragger .splitter-expand-btn:hover::before {
  border-right-color: var(--ids-splitter-expand-btn-hover-arrow-color);
}
:host(.rtl) .splitter-dragger .splitter-expand-btn.is-collapsed {
  left: -12px;
  background-color: var(--ids-splitter-expand-btn-background-color);
  border: 1px solid var(--ids-splitter-expand-btn-border-color);
  box-shadow: var(--ids-splitter-expand-btn-shadow);
  z-index: 1001;
}
:host(.rtl) .splitter-dragger .splitter-expand-btn.is-collapsed::after {
  content: "";
  position: absolute;
  right: -2px;
  top: 0;
  width: 2px;
  height: 100%;
}
:host(.rtl) .splitter-dragger .splitter-expand-btn[data-collapsed=true]::before {
  transform: rotate(0deg);
}
:host(.rtl) .splitter-dragger .splitter-expand-btn[data-collapsed=false]::before {
  transform: rotate(180deg);
}

:host(.is-collapsed) .splitter-dragger .splitter-expand-btn,
:host([data-collapsed=true]) .splitter-dragger .splitter-expand-btn {
  opacity: 1;
  visibility: visible;
  z-index: 1001;
}

.collapsed-edge-hover-area {
  position: absolute;
  top: 0;
  right: 0;
  width: 6px;
  height: 100%;
  z-index: 999;
  cursor: ew-resize;
}
.collapsed-edge-hover-area:hover .splitter-expand-btn {
  opacity: 1;
  visibility: visible;
  right: -22px;
}

:host(.rtl) .collapsed-edge-hover-area {
  right: auto;
  left: 0;
}
:host(.rtl) .collapsed-edge-hover-area .ids-splitter-pane {
  overflow: hidden;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
